import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { constructDate } from '../../../../shared/components/DatePicker/formatDate/constructDate'
import { DatePickerPage } from '../../../../shared/pages/DatePickerPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { DatePickerInputRef } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getDatePickerValidationErrorMessage } from '../../../../shared/utils/getDatePickerValidationErrorMessage/getDatePickerValidationErrorMessage'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { CompanyNameFlow, WorkBeganFlow } from '../../pageFlowData'
import { workBeganData } from './data'

export const WorkBegan: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    work: { date },
  } = state

  const WorkBeganInput = useRef<DatePickerInputRef>(null)

  const [datePickerError, setDatePickerError] = useState('')

  /* v8 ignore next */
  const getValue = () => {
    return cleanText(WorkBeganInput?.current?.datePickerInput?.value || date)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_DATE', data: value })
    dispatch({ type: 'UPDATE_STEP', data: CompanyNameFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: CompanyNameFlow.PROGRESS_VALUE })
  }

  /* v8 ignore next */
  const handleInputChange = (value: string) => {
    /* v8 ignore next */
    dispatch({ type: 'UPDATE_DATE', data: value })
  }

  const handleSubmit = () => {
    setDatePickerError('')
    const dateInputValue: string = getValue()
    const errorMessage = getDatePickerValidationErrorMessage(dateInputValue)
    /* v8 ignore next */
    if (errorMessage) {
      return setDatePickerError(errorMessage)
    }
    const trackingAnswer = `question | ${WorkBeganFlow.VIEW_NAME} | ${dateInputValue}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
    handleDispatch(dateInputValue)
  }

  const { title, imgObj } = workBeganData

  return (
    <DatePickerPage
      buttonText="Next"
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isFocused
      max={constructDate(new Date(), false)}
      newErrorMessage={datePickerError}
      purchasedDate={date}
      ref={WorkBeganInput}
      renderError={datePickerError !== ''}
      testId="work-began"
      title={title}
    />
  )
}
